import { TbLayoutDashboardFilled } from "react-icons/tb";
import { IoCloudUploadOutline, IoLayers } from "react-icons/io5";
import { GrClipboard } from "react-icons/gr";

import { FaCalendar, FaFingerprint } from "react-icons/fa";
import { BiSolidPlane } from "react-icons/bi";
import { HiUsers } from "react-icons/hi2";
import { FaSignalMessenger } from "react-icons/fa6";
import { GoFileDirectoryFill } from "react-icons/go";
import { IoIosSettings } from "react-icons/io";

import {
  FiHome,
  FiCalendar,
  FiUsers,
  FiMessageSquare,
  FiInfo,
  FiSettings,
  FiClipboard,
  FiClock,
  FiLayout,
  FiActivity,
  FiCheckCircle,
  FiTarget,
  FiInstagram,
  FiAlertCircle,
  FiPhone,
  FiDollarSign,
  FiCreditCard,
} from "react-icons/fi";
import { MdOutlineLeaderboard, MdPayments } from "react-icons/md";

export const SIDE_MENU = [
  {
    id: 1,
    title: "Dashboard",
    icon: FiHome,
    path: "/",
    routeKey: "dashboard",
    children: [
      {
        id: 101,
        title: "Main Dashboard",
        path: "/",
        routeKey: "dashboard",
      },
      {
        id: 102,
        title: "Lead Dashboard",
        path: "/lead-dashboard",
        routeKey: "lead-dashboard",
      },
      {
        id: 105,
        title: "Leaderboard",
        path: "/leaderboard",
        routeKey: "leaderboard",
      },
      {
        id: 106,
        title: "HR Dashboard",
        path: "/hr-dashboard",
        routeKey: "hr-dashboard",
      },
      {
        id: 109,
        title: "Digital & Social Dashboard",
        path: "/digital-dashboard",
        routeKey: "digital-dashboard",
      },
      // {
      //   id: 103,
      //   title: "Employee Dashboard",
      //   path: "/employee-dashboard",
      //   routeKey: "employee-dashboard",
      // },
      // {
      //   id: 104,
      //   title: "Cost Dashboard",
      //   path: "/cost-dashboard",
      //   routeKey: "cost-dashboard",
      // },
    ],
  },
  {
    id: 2,
    title: "Clients",
    icon: FiClipboard,
    path: "/projects",
    routeKey: "projects",
  },
  {
    id: 16,
    title: "Issues",
    icon: FiAlertCircle,
    path: "/tickets",
    routeKey: "tickets",
  },
  {
    id: 3,
    title: "Board",
    icon: FiLayout,
    path: "/board",
    routeKey: "board",
  },
  {
    id: 4,
    title: "Calendar",
    icon: FiCalendar,
    path: "/calender",
    routeKey: "calendar",
  },
  {
    id: 5,
    title: "Leave Reports",
    icon: BiSolidPlane,
    path: "/vacations",
    routeKey: "vacations",
  },
  {
    id: 6,
    title: "Employees",
    icon: FiUsers,
    path: "/employees",
    routeKey: "employees",
  },
  {
    id: 7,
    title: "Messenger",
    icon: FiMessageSquare,
    path: "/messenger",
    routeKey: "messenger",
  },
  {
    id: 14,
    title: "Leads",
    icon: MdOutlineLeaderboard,
    path: "/leads",
    routeKey: "leads",
  },
  {
    id: 18,
    title: "My Calls",
    icon: FiPhone,
    path: "/my-calls",
    routeKey: "my-calls",
    children: [
      { id: 181, title: "Today", path: "/my-calls", routeKey: "my-calls" },
      { id: 182, title: "Overdue", path: "/my-calls/overdue", routeKey: "my-calls" },
      { id: 183, title: "Upcoming", path: "/my-calls/upcoming", routeKey: "my-calls" },
      { id: 184, title: "My leads", path: "/my-calls/leads", routeKey: "my-calls" },
    ],
  },
  {
    id: 15,
    title: "Campaigns",
    icon: FiTarget,
    path: "/campaigns",
    routeKey: "campaigns",
  },
  {
    id: 8,
    title: "Task on Review",
    icon: FiActivity,
    path: "/task-on-review",
    routeKey: "task-on-review",
  },
  {
    id: 9,
    title: "Task on Publish",
    icon: IoCloudUploadOutline,
    path: "/task-on-publish",
    routeKey: "task-on-publish",
  },

  {
    id: 10,
    title: "Client Review",
    icon: FiCheckCircle,
    path: "/client-review",
    routeKey: "client-review",
  },
  {
    id: 11,
    title: "Attendance",
    icon: FaFingerprint,
    path: "/attendance",
    routeKey: "attendance",
  },
  {
    id: 19,
    title: "Accounts",
    icon: FiDollarSign,
    path: "/accounts",
    routeKey: "accounts",
  },
  {
    id: 20,
    title: "My Payslips",
    icon: FiCreditCard,
    path: "/my-payslips",
    routeKey: "my-payslips",
  },
  // {
  //   id: 9,
  //   title: "Info Portal",
  //   icon: FiInfo,
  //   path: "/infoPortal",
  //   routeKey: "infoPortal",
  // },
  // {
  //   id: 10,
  //   title: "Events",
  //   icon: FiCalendar,
  //   path: "/events",
  //   routeKey: "events",
  // },

  {
    id: 12,
    title: "Settings",
    icon: FiSettings,
    path: "/settings",
    routeKey: "settings",
  },
];

export const USERS = [
  {
    name: "Oscar Holloway",
    avatar: "avatar1.svg",
    email: "abc@gmail.com",
    leave: { date: ["12/02/2025"], status: "approved" },
    approved: { date: ["07/02/2025", "08/02/2025"], status: "pending" },
    remote: { date: ["01/02/2025"], status: "pending" },
    vacation: 5,
    sickLeave: 2,
    workRemote: 10,
  },
  {
    name: "Evan Yates",
    avatar: "avatar2.svg",
    email: "abc@gmail.com",
    leave: { date: ["04/02/2025"], status: "approved" },
    approved: { date: [], status: "pending" },
    remote: { date: ["01/02/2025"], status: "approved" },
    vacation: 3,
    sickLeave: 1,
    workRemote: 8,
  },
  {
    name: "Lola Zimmerman",
    avatar: "avatar3.svg",
    email: "abc@gmail.com",
    leave: { date: ["07/02/2025"], status: "approved" },
    approved: { date: ["23/02/2025", "22/02/2025"], status: "approved" },
    remote: { date: ["01/02/2025"], status: "approved" },
    vacation: 7,
    sickLeave: 4,
    workRemote: 12,
  },
  {
    name: "Tyler Curry",
    avatar: "avatar4.svg",
    email: "abc@gmail.com",
    leave: { date: ["11/02/2025"], status: "approved" },
    approved: { date: ["23/02/2025"], status: "approved" },
    remote: { date: ["01/02/2025"], status: "pending" },
    vacation: 4,
    sickLeave: 2,
    workRemote: 6,
  },
  {
    name: "Sadie Wolfe",
    avatar: "avatar5.svg",
    email: "abc@gmail.com",
    leave: { date: ["20/02/2025"], status: "approved" },
    approved: { date: ["23/02/2025"], status: "approved" },
    remote: { date: ["01/02/2025"], status: "approved" },
    vacation: 6,
    sickLeave: 3,
    workRemote: 9,
  },
  {
    name: "Sean Gibbs",
    avatar: "avatar6.svg",
    email: "abc@gmail.com",
    leave: { date: ["22/02/2025"], status: "approved" },
    approved: { date: ["04/02/2025"], status: "approved" },
    remote: { date: ["01/02/2025"], status: "approved" },
    vacation: 5,
    sickLeave: 2,
    workRemote: 11,
  },
  {
    name: "Corey Watts",
    avatar: "avatar7.svg",
    email: "abc@gmail.com",
    leave: { date: ["05/02/2025"], status: "approved" },
    approved: { date: ["09/02/2025", "10/02/2025"], status: "approved" },
    remote: { date: ["21/02/2025"], status: "approved" },
    vacation: 8,
    sickLeave: 3,
    workRemote: 14,
  },
  {
    name: "Theodore Shaw",
    avatar: "avatar8.svg",
    email: "abc@gmail.com",
    leave: { date: ["07/02/2025"], status: "approved" },
    approved: { date: ["31/02/2025"], status: "approved" },
    remote: { date: ["01/02/2025"], status: "approved" },
    vacation: 6,
    sickLeave: 4,
    workRemote: 10,
  },
  {
    name: "Edwin Austin",
    avatar: "avatar9.svg",
    email: "abc@gmail.com",
    leave: { date: ["28/02/2025"], status: "approved" },
    approved: {
      date: ["23/02/2025", "25/02/2025", "26/02/2025"],
      status: "approved",
    },
    remote: {
      date: ["27/02/2025", "28/02/2025", "29/02/2025"],
      status: "pending",
    },
    vacation: 5,
    sickLeave: 2,
    workRemote: 9,
  },
  {
    name: "Thomas Cummings",
    avatar: "avatar10.svg",
    email: "abc@gmail.com",
    leave: { date: ["19/02/2025"], status: "approved" },
    approved: { date: ["02/02/2025", "03/02/2025"], status: "approved" },
    remote: { date: ["05/02/2025"], status: "approved" },
    vacation: 7,
    sickLeave: 3,
    workRemote: 11,
  },
  {
    name: "Augusta Gordon",
    avatar: "avatar11.svg",
    email: "abc@gmail.com",
    leave: { date: ["17/02/2025"], status: "approved" },
    approved: { date: ["23/02/2025"], status: "approved" },
    remote: { date: ["01/02/2025", "02/02/2025"], status: "approved" },
    vacation: 6,
    sickLeave: 2,
    workRemote: 10,
  },
];

export const EMPOYEES = [
  {
    name: "Evan Yates",
    email: "evanyates@gmail.com",
    gender: "Male",
    birthday: "Apr 12, 1995",
    full_age: 25,
    position: "UI/UX Designer",
    level: "Middle",
    backlog_tasks: 0,
    tasks_in_progress: 16,
    tasks_in_review: 6,
    progress_value: 50,
    profile: "avatar1.svg",
  },
  {
    name: "Lenora Fowler",
    email: "eravi@ec.gov",
    gender: "Female",
    birthday: "Apr 28, 1998",
    full_age: 23,
    position: "UI/UX Designer",
    level: "Junior",
    backlog_tasks: 1,
    tasks_in_progress: 20,
    progress_value: 70,
    tasks_in_review: 2,
    profile: "avatar2.svg",
  },
  {
    name: "Winnie McGuire",
    email: "winnie3498@gmail.com",
    gender: "Female",
    birthday: "Apr 12, 1995",
    full_age: 25,
    position: "Copywriter",
    level: "Senior",
    backlog_tasks: 0,
    progress_value: 88,
    tasks_in_progress: 20,
    tasks_in_review: 2,
    profile: "avatar3.svg",
  },
  {
    name: "James Williamson",
    email: "williamsonj@gmail.com",
    gender: "Male",
    birthday: "Sep 23, 1992",
    full_age: 28,
    position: "iOS Developer",
    level: "Middle",
    progress_value: 90,
    backlog_tasks: 1,
    tasks_in_progress: 20,
    tasks_in_review: 2,
    profile: "avatar4.svg",
  },
  {
    name: "Emily Tyler",
    email: "tyleremily24@gmail.com",
    gender: "Female",
    birthday: "May 16, 1996",
    full_age: 24,
    position: "UI/UX Designer",
    level: "Junior",
    backlog_tasks: 0,
    progress_value: 50,
    tasks_in_progress: 20,
    tasks_in_review: 2,
    profile: "avatar5.svg",
  },
  {
    name: "Thomas Schneider",
    email: "thomas.s@gmail.com",
    gender: "Male",
    birthday: "Apr 28, 1998",
    full_age: 23,
    position: "Sales Manager",
    level: "Junior",
    progress_value: 45,
    backlog_tasks: 1,
    tasks_in_progress: 14,
    tasks_in_review: 3,
    profile: "avatar6.svg",
  },
  {
    name: "Sallie Long",
    email: "sallielong@gmail.com",
    gender: "Female",
    birthday: "Apr 12, 1995",
    full_age: 25,
    position: "Copywriter",
    progress_value: 10,
    level: "Middle",
    backlog_tasks: 0,
    tasks_in_progress: 8,
    tasks_in_review: 6,
    profile: "avatar7.svg",
  },
  {
    name: "Kathryn Guerrero",
    email: "kathryn1992@gmail.com",
    gender: "Female",
    birthday: "Sep 23, 1992",
    full_age: 28,
    position: "iOS Developer",
    level: "Senior",
    progress_value: 20,
    backlog_tasks: 1,
    tasks_in_progress: 20,
    tasks_in_review: 2,
    profile: "avatar8.svg",
  },
];
import { FaRegUser, FaDatabase, FaScaleBalanced } from "react-icons/fa6";
import { IoIosNotificationsOutline } from "react-icons/io";
import { BsBuildings } from "react-icons/bs";
import { AiOutlineSafety } from "react-icons/ai";

export const SETTINGS = [
  {
    id: 1,
    title: "Account",
    icon: FaRegUser,
    path: "account",
  },
  // {
  //   id: 2,
  //   title: "Notifications",
  //   icon: IoIosNotificationsOutline,
  //   path: "notifications",
  // },
  {
    id: 3,
    title: "My Company",
    icon: BsBuildings,
    path: "company",
  },
  {
    id: 4,
    title: "Security",
    icon: AiOutlineSafety,
    path: "safety",
  },
  {
    id: 5,
    title: "Billing & Usage",
    icon: MdPayments,
    path: "billing",
  },
  {
    id: 7,
    title: "Integration",
    icon: FiActivity,
    path: "integration",
  },
  {
    id: 6,
    title: "Master",
    icon: FaDatabase,
    path: "master",
  },
  {
    id: 8,
    title: "Rules",
    icon: FaScaleBalanced,
    path: "rules",
  },
];
